/**
 * Gets the configuration object passed to `fetch`
 *
 * @param  {Object} config: options to configure the request.
 * @return {Object}
 */
export default function mergeConfig(config) {
  return Object.assign({
    url: null,
    method: 'GET',
    headers: {},
    data: null,
    // for CORS requests, use the "include" to allow sending credentials to other domains
    // @see https://github.com/github/fetch#sending-cookies
    credentials: 'omit',
  }, config);
}
